import React from 'react';
import { graphql } from 'react-apollo';
import Spinner from '../../spinner/spinner';
import { Button, Form } from 'antd';
import FaqAnswerForm from './faqAnswerForm';
import { createFaqAnswer } from './mutations/createFaqAnswer';

class CreateFaqAnswer extends React.Component {
  mutationParams = () => {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue()
        }
      }
    }
  };

  redirectTo = (data) => {
    this.props.history.push(`/dashboard/admin/faqAnswersList?faqAnswer=${data.createFaqAnswer.faqAnswer.id}`);
  };

  formControls(loading) {
    return (
      <Button type="primary" htmlType="submit" className="login-form__login-button" loading={loading}>
        Create FAQ Answer
      </Button>
    );
  }

  render() {
    if (this.props.data.loading) {
      return (
        <Spinner/>
      );
    } else {
      return (
        <FaqAnswerForm {...this.props } formControls={this.formControls}
                             mutationParams={this.mutationParams}
                             redirectTo={this.redirectTo}/>
      );
    }
  }
}

export default Form.create()(graphql(createFaqAnswer)(CreateFaqAnswer));




// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/createFaqAnswer.js